
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'filter',
    standalone: false
})
export class FilterPipe implements PipeTransform {

  transform(items: any[], searchText: string, field: string): any[] {
    if (!items) return [];
    if (!searchText) return items;

    searchText = searchText.toString().toLowerCase();

    return items.filter(it => {
      return it[field].toString().toLowerCase().includes(searchText);
    });
  }
}
